'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { withRouter } from 'react-router-dom';
import LessonNavigatorContainer from './LessonNavigator/ExpandedLessonNavigatorLessonContainer';
import TrackNavigatorContainer from './TrackNavigator/TrackNavigatorContainer';

const SmartNavigator = ({
  match: {
    params: {
      trackId
    } = {}
  }
}) => trackId ? /*#__PURE__*/_jsx(TrackNavigatorContainer, {}) : /*#__PURE__*/_jsx(LessonNavigatorContainer, {});

export default withRouter(SmartNavigator);